import type {
  EditionMetaData,
  MetaData,
} from "@/pages/human-resources/time-management/business/MetaData.ts";
import { parseIsoDateTime } from "@/shared/utils/Dates.ts";

export type MetaDataOut = CreationMetaDataOut & EditionMetaDataOut;

interface CreationMetaDataOut {
  createdDate: string | undefined;
  createdBy: number | undefined;
  createdByUsername: string | undefined;
}

interface EditionMetaDataOut {
  lastModifiedDate: string | undefined;
  lastModifiedBy: number | undefined;
  lastModifiedByUsername: string | undefined;
}

export function mapToMetaData(dto: MetaDataOut): MetaData {
  const created = mapCreatedFields(dto);
  const modified = mapModifiedFields(dto);
  if (created === undefined) {
    throw new Error("No creation metadata found");
  }
  return { created, modified: modified ?? created };
}

function mapCreatedFields(
  dto: CreationMetaDataOut,
): EditionMetaData | undefined {
  return mapValues(dto.createdDate, dto.createdBy, dto.createdByUsername);
}

function mapModifiedFields(
  dto: EditionMetaDataOut,
): EditionMetaData | undefined {
  return mapValues(
    dto.lastModifiedDate,
    dto.lastModifiedBy,
    dto.lastModifiedByUsername,
  );
}

function mapValues(
  dateStr: string | undefined,
  userId: number | undefined,
  username: string | undefined,
): EditionMetaData | undefined {
  if (dateStr === undefined || userId === undefined || username === undefined) {
    return undefined;
  }
  return {
    date: parseIsoDateTime(dateStr),
    userId: userId.toString(),
    username,
  };
}
